import type { TCheckboxSizes } from '../../types'
import { checkboxLabelVariants } from './checkbox.label.styles'

type TCheckboxLabelProps = {
  children: string
  size?: TCheckboxSizes
  error?: boolean
  disabled?: boolean
  readonly?: boolean
}

export function CheckboxLabel({
  children: label,
  size = 'md',
  error = false,
  disabled = false,
  readonly = false,
}: TCheckboxLabelProps) {
  return (
    <span
      className={checkboxLabelVariants({
        size,
        hasError: error,
        hasDisabled: disabled,
        hasReadonly: readonly,
        className: !label && 'hidden',
      })}
    >
      {label}
    </span>
  )
}
